import { useQueryFetch } from '@shared/hooks/useQueryFetch';
import { TableFieldSelectionRecordVM } from '@shared/types/process';
import { PaginatedResponse } from '@shared/types/types';

type SelectionRecordsParams = {
    serviceId?: string;
    serviceProcessFieldId?: string;
    search?: string;
    excludeRecordIds?: string[];
    page?: number;
    size?: number;
    enabled?: boolean;
};

export function useSelectionRecords({
    serviceId,
    serviceProcessFieldId,
    search,
    excludeRecordIds = [],
    page = 1,
    size = 50,
    enabled = true,
}: SelectionRecordsParams) {
    return useQueryFetch<
        PaginatedResponse<TableFieldSelectionRecordVM>,
        TableFieldSelectionRecordVM[]
    >('flow/ServiceProcessTableFields/SelectionRecords', {
        enabled:
            Boolean(serviceProcessFieldId) && Boolean(serviceId) && enabled,
        hideErrorNotification: true,
        params: {
            ...(serviceId ? { serviceId } : {}),
            serviceProcessFieldId,
            search: search || undefined,
            excludeRecordIds,
            page,
            size,
        },
        select(data) {
            return data?.itemList ?? [];
        },
    });
}
